// assets
import { Route, AccountTree, LocationOn } from '@mui/icons-material';

// ==============================|| MENU ITEMS - STATIONS ||============================== //

const stations = {
    id: 'group-stations',
    title: 'Stations',
    type: 'group',
    children: [
        {
            id: 'routes',
            title: 'Routes',
            type: 'item',
            url: '/stations/routes',
            icon: Route,
            breadcrumbs: false
        },
        {
            id: 'route-templates',
            title: 'Route Templates',
            type: 'item',
            url: '/stations/route-templates',
            icon: AccountTree,
            breadcrumbs: false
        },
        {
            id: 'stations',
            title: 'Stations',
            type: 'item',
            url: '/stations/stations',
            icon: LocationOn,
            breadcrumbs: false
        }
    ]
};

export default stations;
